<button
  #cmYear
  pButton
  size="small"
  pTooltip="Rechtsklick für weitere Optionen."
  [showDelay]="600"
  [rounded]="true"
  [severity]="dataLayer.isForecast ? 'help' : 'primary'"
  [icon]="iconByPublishedState"
  [label]="dataLayer.year + ''"
  (click)="selectDataLayer()"
  [ngClass]="{
    'p-button-raised p-button-text':
      dataLayer._id !== globalStore.selectedLayer()?._id,
  }"></button>

<p-contextMenu
  appendTo="body"
  [target]="cmYear"
  (onShow)="setItems()"
  [model]="contextMenuItems" />
